import { Breadcrumb, Button, Col, Empty, Form, Icon, Input, message, Pagination, Row, Table } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component, FormEvent } from 'react';
import { Query } from 'react-apollo';
import { Link } from 'react-router-dom';
import { PageInfo } from 'src/types/base';

import { Panel } from '../../components/Panel';
import { GTeacher } from '../../types/teacher';
import { CreateTeacher } from './CreateTeacher';

export const teachersConnectionQuery = gql`
  query getTeachersQuery($name: String, $take: Int, $skip: Int, $after: ID, $before: ID) {
    teachersConnection(name: $name, take: $take, skip: $skip, after: $after, before: $before) {
      nodes {
        id
        name
        enrollmentGroups {
          id
          name
          createdAt
          sku {
            id
            name
            start
            end
            availableFrom
            availableUntil
            # workGoal {
            #   closeStageStartAt
            #   closeStageEndAt
            # }
          }
          enrollments {
            id
          }
        }
      }
      pageInfo {
        totalCount
        startCursor
        endCursor
      }
    }
  }
`;
const TEACHERS_COUNT_PER_PAGE = 10;
interface State {
  teacherNameInputValue: string;
  isCreateTeacherVisible: boolean;
  variables: {
    name: string;
    take: number;
    skip?: number;
    before?: number;
    after?: number;
  };
  currentPage: number;
}
interface Props {
  form: WrappedFormUtils;
}

export class TeacherListForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      teacherNameInputValue: '',
      isCreateTeacherVisible: false,
      variables: {
        name: '',
        skip: 0,
        take: TEACHERS_COUNT_PER_PAGE,
      },
      currentPage: 1,
    };

    this.search = this.search.bind(this);
    this.onResetClick = this.onResetClick.bind(this);
    this.onCreateTeacherClick = this.onCreateTeacherClick.bind(this);
    this.onCancelCreateTeacher = this.onCancelCreateTeacher.bind(this);
  }

  search(e: FormEvent) {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        message.error(err);
        return;
      }
      this.setState({
        teacherNameInputValue: values.teacherNameInputValue,
        variables: {
          name: values.teacherNameInputValue,
          take: TEACHERS_COUNT_PER_PAGE,
          skip: 0,
        },
        currentPage: 1,
      });
    });
  }

  onCreateTeacherClick() {
    this.setState({
      isCreateTeacherVisible: true,
    });
  }

  onCancelCreateTeacher() {
    this.hideCreateTeacher();
  }

  hideCreateTeacher() {
    this.setState({
      isCreateTeacherVisible: false,
    });
  }

  onResetClick() {
    this.setState({
      teacherNameInputValue: '',
    });
  }

  render() {
    const { currentPage, variables, isCreateTeacherVisible } = this.state;
    const { getFieldDecorator } = this.props.form;
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>班主任管理</Breadcrumb.Item>
        </Breadcrumb>
        <Query<{ teachersConnection: { nodes: GTeacher[]; pageInfo: PageInfo } }>
          query={teachersConnectionQuery}
          variables={variables}
        >
          {({ loading, error, data, refetch }) => {
            if (error) return <div>{error.message}</div>;
            if (loading) return <div>loading...</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const teachersConnection = (data && data.teachersConnection) || [];

            return (
              <>
                <CreateTeacher
                  isVisible={isCreateTeacherVisible}
                  hide={() => {
                    this.hideCreateTeacher();
                  }}
                  onSuccess={async () => {
                    await refetch();
                  }}
                  onCancel={this.onCancelCreateTeacher}
                />
                <Panel style={{ padding: 24 }}>
                  <Form onSubmit={this.search}>
                    <Row style={{ marginTop: 8 }}>
                      <Col span={24} style={{ textAlign: 'right' }}>
                        <Col xs={24} md={24} lg={21} xl={13} xxl={13} style={{ textAlign: 'left', marginTop: 7 }}>
                          <Form.Item label={`班主任微信号：`}>
                            {getFieldDecorator('teacherNameInputValue')(<Input allowClear />)}
                          </Form.Item>
                        </Col>
                        <Col xs={24} md={24} lg={24} xl={9} xxl={9}>
                          <Button style={{ marginRight: 8 }} icon="download">
                            导出
                          </Button>
                          <Button style={{ marginRight: 8 }} type="primary" onClick={this.onResetClick}>
                            重置
                          </Button>
                          <Button type="primary" htmlType="submit">
                            <Icon type="search" />
                            搜索
                          </Button>
                        </Col>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: 12 }}>
                      <Col span={24} style={{ textAlign: 'left' }}>
                        <Button icon="plus" onClick={this.onCreateTeacherClick}>
                          添加老师
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Panel>
                <Panel style={{ marginTop: 16 }}>
                  <Table
                    pagination={false}
                    dataSource={teachersConnection.nodes}
                    loading={loading}
                    rowKey={teacher => `${teacher.id}`}
                    footer={() => (
                      <Pagination
                        style={{ float: 'right', marginBottom: 16 }}
                        total={teachersConnection.pageInfo.totalCount}
                        pageSize={variables.take}
                        current={currentPage}
                        onChange={nextPage => {
                          const pageSkip = (Math.abs(nextPage - currentPage) - 1) * TEACHERS_COUNT_PER_PAGE;

                          if (nextPage > currentPage) {
                            this.setState({
                              variables: {
                                name: this.state.teacherNameInputValue,
                                skip: pageSkip,
                                take: TEACHERS_COUNT_PER_PAGE,
                                after: teachersConnection.pageInfo.endCursor,
                              },
                            });
                          }
                          if (nextPage < currentPage) {
                            this.setState({
                              variables: {
                                name: this.state.teacherNameInputValue,
                                skip: pageSkip,
                                take: TEACHERS_COUNT_PER_PAGE,
                                before: teachersConnection.pageInfo.startCursor,
                              },
                            });
                          }
                          this.setState({
                            currentPage: nextPage,
                          });
                        }}
                      />
                    )}
                  >
                    <Table.Column title="班主任微信号" dataIndex="name" key="teacherName" />
                    <Table.Column title="总班级数" dataIndex="enrollmentGroups.length" key="classCount" />
                    <Table.Column
                      title="准备期班级"
                      dataIndex="enrollmentGroups"
                      key="availableclassCount"
                      render={enrollmentGroups => {
                        let count = 0;
                        const now = moment().utcOffset(8).format('YYYY-MM-DD HH:mm:ss');
                        for (const enrollmentGroup of enrollmentGroups || []) {
                          if (enrollmentGroup.sku.availableFrom <= now && now <= enrollmentGroup.sku.start) {
                            count += 1;
                          }
                        }
                        return count;
                      }}
                    />
                    <Table.Column
                      title="服务期班级"
                      dataIndex="enrollmentGroups"
                      key="serviceclassCount"
                      render={enrollmentGroups => {
                        let count = 0;
                        const now = moment().utcOffset(8).format('YYYY-MM-DD HH:mm:ss');
                        for (const enrollmentGroup of enrollmentGroups || []) {
                          if (
                            enrollmentGroup.sku.workGoal &&
                            enrollmentGroup.sku.start <= now &&
                            now <= enrollmentGroup.sku.workGoal.closeStageStartAt
                          ) {
                            count += 1;
                          }
                        }
                        return count;
                      }}
                    />
                    <Table.Column
                      title="关单期班级"
                      dataIndex="enrollmentGroups"
                      key="closeOrderclassCount"
                      render={enrollmentGroups => {
                        let count = 0;
                        const now = moment().utcOffset(8).format('YYYY-MM-DD HH:mm:ss');
                        for (const enrollmentGroup of enrollmentGroups || []) {
                          if (
                            enrollmentGroup.sku.workGoal &&
                            enrollmentGroup.sku.workGoal.closeStageStartAt <= now &&
                            now <= enrollmentGroup.sku.workGoal.closeStageEndAt
                          ) {
                            count += 1;
                          }
                        }
                        return count;
                      }}
                    />

                    <Table.Column
                      title="总学生数"
                      dataIndex="enrollmentGroups"
                      key="memberCount"
                      render={enrollmentGroups => {
                        let count = 0;
                        for (const enrollmentGroup of enrollmentGroups || []) {
                          count += enrollmentGroup.enrollments.length;
                        }
                        return count;
                      }}
                    />
                    <Table.Column
                      title="准备期学生"
                      dataIndex="enrollmentGroups"
                      key="availableCourseMemberCount"
                      render={enrollmentGroups => {
                        let count = 0;
                        const now = moment().utcOffset(8).format('YYYY-MM-DD HH:mm:ss');
                        for (const enrollmentGroup of enrollmentGroups || []) {
                          if (enrollmentGroup.sku.availableFrom <= now && now <= enrollmentGroup.sku.start) {
                            count += enrollmentGroup.enrollments.length;
                          }
                        }
                        return count;
                      }}
                    />
                    <Table.Column
                      title="服务期学生"
                      dataIndex="enrollmentGroups"
                      key="startToEndCourseMemberCount"
                      render={enrollmentGroups => {
                        let count = 0;
                        const now = moment().utcOffset(8).format('YYYY-MM-DD HH:mm:ss');
                        for (const enrollmentGroup of enrollmentGroups || []) {
                          if (
                            enrollmentGroup.sku.workGoal &&
                            enrollmentGroup.sku.start <= now &&
                            now <= enrollmentGroup.sku.workGoal.closeStageStartAt
                          ) {
                            count += enrollmentGroup.enrollments.length;
                          }
                        }
                        return count;
                      }}
                    />
                    <Table.Column
                      title="关单期学生"
                      dataIndex="enrollmentGroups"
                      key="closeOrderMemberCount"
                      render={enrollmentGroups => {
                        let count = 0;
                        const now = moment().utcOffset(8).format('YYYY-MM-DD HH:mm:ss');
                        for (const enrollmentGroup of enrollmentGroups || []) {
                          if (
                            enrollmentGroup.sku.workGoal &&
                            enrollmentGroup.sku.workGoal.closeStageStartAt <= now &&
                            now <= enrollmentGroup.sku.workGoal.closeStageEndAt
                          ) {
                            count += enrollmentGroup.enrollments.length;
                          }
                        }
                        return count;
                      }}
                    />
                    <Table.Column<{ name: string }>
                      title="操作"
                      dataIndex="id"
                      key="actions"
                      render={id => <Link to={`/teacher/${id}`}>查看详情</Link>}
                    />
                  </Table>
                </Panel>
              </>
            );
          }}
        </Query>
      </>
    );
  }
}

export const TeacherList = Form.create({ name: 'TeacherList' })(TeacherListForm);



// WEBPACK FOOTER //
// ./src/screens/teacher/TeacherList.tsx